/*
  Keep action/resource static — see dashboard.js for why ability.can() at
  import time breaks the sidebar after login until refresh.
*/
export default [
  {
    header: 'Apps & Pages',
    resource: 'apps_list',
    action: 'read',
  },
  {
    title: 'Jobs',
    icon: 'BriefcaseIcon',
    route: 'apps-jobs',
    resource: 'jobs',
    action: 'read',
  },
  {
    title: 'Tasks',
    icon: 'CheckSquareIcon',
    route: 'apps-tasks',
    resource: 'task_management',
    action: 'read',
  },
  {
    title: 'My Candidates',
    route: 'apps-my-candidates',
    icon: 'UsersIcon',
    resource: 'my_candidates',
    action: 'read',
  },
  {
    title: 'Call Analytics',
    route: 'apps-call-analytics',
    icon: 'PhoneCallIcon',
    resource: 'call_analytics',
    action: 'read',
  },
  {
    title: 'Trackers',
    icon: 'ClipboardIcon',
    children: [
      {
        title: 'Interview Tracker',
        route: 'apps-interview-tracker',
        icon: 'CalendarIcon',
        resource: 'interview',
        action: 'read',
      },
      {
        title: 'POFU Tracker',
        route: 'apps-pofu-tracker',
        icon: 'PackageIcon',
        resource: 'pofu',
        action: 'read',
      },
    ],
  },
  {
    title: 'Onboarding',
    icon: 'AwardIcon',
    children: [
      {
        title: 'Client Dashboard',
        route: 'dashboard-client-selection',
        icon: 'MonitorIcon',
        clientDashboardAccess: true,
      },
      {
        title: 'Offer Templates',
        route: 'apps-offer-configure',
        icon: 'FileTextIcon',
        resource: 'offer_configure',
        action: 'read',
      },
    ],
  },
  {
    title: 'Candidates DB',
    icon: 'DatabaseIcon',
    resource: 'boolean_search',
    action: 'read',
    children: [
      {
        title: 'Candidates Boolean Search',
        route: 'apps-candidates-search',
        icon: 'SearchIcon',
        resource: 'boolean_search',
        action: 'read',
      },
      {
        title: 'Add Candidates',
        route: 'apps-candidates-add',
        icon: 'UserPlusIcon',
        resource: 'candidates',
        action: 'read',
      },
    ],
  },
  {
    // No parent resource: show group when any child is visible (report OR
    // recruiter_report / statuswise_report), matching prior OR intent.
    title: 'Reports',
    icon: 'BarChart2Icon',
    children: [
      {
        title: 'Recruiter Worktracker',
        route: 'apps-reports-recruiter',
        icon: 'ActivityIcon',
        resource: 'recruiter_report',
        action: 'read',
      },
      {
        title: 'Status Wise Tracker',
        route: 'apps-reports-status-wise',
        icon: 'PieChartIcon',
        resource: 'statuswise_report',
        action: 'read',
      },
    ],
  },
  {
    title: 'Finance',
    icon: 'LayersIcon',
    children: [
      /* {
        title: 'LinkedIn Job Post',
        route: 'apps-linkedin-job-post',
        icon: 'LinkedinIcon',
        resource: 'linkedin_post',
        action: 'read',
      }, */
      {
        title: 'Invoice Tracker',
        route: 'apps-invoice-tracker',
        icon: 'DollarSignIcon',
        resource: 'invoice',
        action: 'read',
      },
      /* {
        title: 'Expense Tracker',
        route: 'apps-expense-tracker',
        icon: 'ZapIcon',
        resource: 'expense',
        action: 'read',
      }, */
      {
        title: 'Reimbursement',
        route: 'apps-reimbursement',
        icon: 'CreditCardIcon',
        resource: 'reimbursement',
        action: 'read',
      },
    ],
  },
  {
    title: 'Client Recruiters List',
    route: 'apps-client-recruiters-list',
    icon: 'UserIcon',
    resource: 'client_recruiter',
    action: 'read',
  },
]
